<template>
    <BaseTooltip open-on-click side="top" :side-offset="8" content-class="max-w-80 p-3 text-left shadow-lg" :trigger-aria-label="triggerAriaLabel">
        <template #trigger>
            <BaseButton theme="tertiary" size="sm" icon-only class="shrink-0" :aria-label="triggerAriaLabel">
                <i class="bi bi-info-circle text-base" aria-hidden="true"></i>
            </BaseButton>
        </template>
        <template #content>
            <p v-if="regeneration" class="body-small">{{ t("profile.collaboration.tooltip.regenerationDescription") }}</p>
            <p v-else class="body-small">{{ t("profile.collaboration.tooltip.description") }}</p>
        </template>
    </BaseTooltip>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseTooltip from "~vue/components/BaseTooltip.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { regeneration = false } = defineProps<{ regeneration?: boolean }>();

const triggerAriaLabel = computed(() => (regeneration ? t("profile.collaboration.tooltip.regenerationLabel") : t("profile.collaboration.tooltip.label")));
</script>
